
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summit",
      function () {
        return require("private-next-pages/summit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/summit"])
      });
    }
  